import { render, staticRenderFns } from "./VariablesDropdown.vue?vue&type=template&id=2fa40bbb"
import script from "./VariablesDropdown.vue?vue&type=script&lang=js"
export * from "./VariablesDropdown.vue?vue&type=script&lang=js"
import style0 from "./VariablesDropdown.vue?vue&type=style&index=0&id=2fa40bbb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports